// extracted by mini-css-extract-plugin
export var fadeIn = "_du-1";
export var modalContent = "_du-3";
export var overlay = "_du-0";
export var popoverContent = "_du-2";
export var results = "_du-5";
export var searchInputWrapper = "_du-4";